var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQrIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 7.25C9.42893 7.25 7.75 8.92893 7.75 11V12C7.75 12.4142 8.08579 12.75 8.5 12.75C8.91421 12.75 9.25 12.4142 9.25 12V11C9.25 9.75736 10.2574 8.75 11.5 8.75H12.5C12.9142 8.75 13.25 8.41421 13.25 8C13.25 7.58579 12.9142 7.25 12.5 7.25H11.5ZM20.5 7.25C20.0858 7.25 19.75 7.58579 19.75 8C19.75 8.41421 20.0858 8.75 20.5 8.75H21.5C22.7426 8.75 23.75 9.75736 23.75 11V12C23.75 12.4142 24.0858 12.75 24.5 12.75C24.9142 12.75 25.25 12.4142 25.25 12V11C25.25 8.92893 23.5711 7.25 21.5 7.25H20.5ZM9.25 20C9.25 19.5858 8.91421 19.25 8.5 19.25C8.08579 19.25 7.75 19.5858 7.75 20V21C7.75 23.0711 9.42893 24.75 11.5 24.75H12.5C12.9142 24.75 13.25 24.4142 13.25 24C13.25 23.5858 12.9142 23.25 12.5 23.25H11.5C10.2574 23.25 9.25 22.2426 9.25 21V20ZM25.25 20C25.25 19.5858 24.9142 19.25 24.5 19.25C24.0858 19.25 23.75 19.5858 23.75 20V21C23.75 22.2426 22.7426 23.25 21.5 23.25H20.5C20.0858 23.25 19.75 23.5858 19.75 24C19.75 24.4142 20.0858 24.75 20.5 24.75H21.5C23.5711 24.75 25.25 23.0711 25.25 21V20ZM8.5 15.25C8.08579 15.25 7.75 15.5858 7.75 16C7.75 16.4142 8.08579 16.75 8.5 16.75H24.5C24.9142 16.75 25.25 16.4142 25.25 16C25.25 15.5858 24.9142 15.25 24.5 15.25H8.5Z",
  fill: "#676879"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgQrIcon);
export default ForwardRef;